import { createAction, createSelector, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';
import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';
import { configurationService, financePartnerService } from 'services';

const adapter = createEntityAdapter({});

const slice = createSlice({
  name: 'authorizedSignatoryCompanies',
  initialState: adapter.getInitialState({
    busy: false,
  }),
  reducers: {
    setAll: adapter.setAll,
    addOne: adapter.addOne,
    addMany: adapter.addMany,
    updateOne: adapter.updateOne,
    updateMany: adapter.updateMany,
    upsertOne: adapter.upsertOne,
    upsertMany: adapter.upsertMany,
    removeOne: adapter.removeOne,
    removeMany: adapter.removeMany,
    removeAll: adapter.removeAll,
    setBusy(state, action) {
      let busy = action.payload;
      if (busy === false) {
        state.busy = false;
      } else {
        state.busy = true;
      }
    },
  },
});

const fetchList = () => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await configurationService.fetchCompanyList();
    dispatch(slice.actions.setAll(resData));
  } catch (err) {
    dispatch(slice.actions.setAll({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const fetchCreditLimitCompanyList = () => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await financePartnerService.fetchCreditLimitCompanyList();
    dispatch(slice.actions.setAll(resData));
  } catch (err) {
    dispatch(slice.actions.setAll({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const actions = {
  ...slice.actions,
  fetchList,
  fetchCreditLimitCompanyList,
};

const selectors = {
  ...adapter.getSelectors((state) => state.authorizedSignatoryCompanies),
};

export { actions, selectors };

export default slice.reducer;
